export const DEFAULT_DELIVERY_TIMEFRAME = 2;
export const DEFAULT_TIMEFRAME_BUFFER = 60;
export const DEFAULT_SERVICE_TIME_INCREMENT = 15;
export const DEFAULT_SERVICE_TIME = 30;
export const DEFAULT_SERVICE_TIME_C = 10;
export const DEFAULT_SERVICE_TIME_FDS = 15;
export const DEFAULT_SERVICE_TIME_ROC = 25;
export const DEFAULT_SERVICE_TIME_WG = 35;
